import { jwtDecode } from "jwt-decode"
import { useMemo } from "react"

export const useToken = () => {
    const token = localStorage.getItem('token')


    const isConnectedAsCsm = useMemo(() => {

        if (!token) return false
        //decode token
        try {
            let decoded_token = jwtDecode(token)
            return 'iu' in decoded_token
        } catch (error) {
            return false
        }


    }, [token])

    return {
        isConnectedAsCsm
    }
}